import { Packages } from "../globalTypes";
import { FormInputs } from "../Components/Content";
import { strings } from "../constants";
import { getTrackingInfo } from "../utils/tracking";
import { getPacketName } from "./NetvisorPacket";
import { isNewCampaignActivated } from "./NewCampaign";

type EnrichmentContext = {
  orderPrice: number;
  turnoverCategory: string;
  informationProcessingConsentText: string;
};

// Every client-supplied value is capped - free-text, cookie-fed and the URL-fed packet alike: the whole object ships as CompanyCreationRequest.Enrichment, whose [StringLength(16000)] is enforced by OpenApp before login - an overflow there is a raw 400 on the form POST, i.e. a dead purchase.
export function buildLeadEnrichment(
  formInputs: FormInputs,
  context: EnrichmentContext
) {
  return {
    selectedPackage: cap(
      getPacketName().toString().toUpperCase(),
      50
    ) as Packages,
    turnoverCategory: context.turnoverCategory,
    companyForm: cap(formInputs.companyForm?.label as string, 100),
    informationProcessingConsentText: cap(
      context.informationProcessingConsentText,
      1000
    ),
    cmrr: context.orderPrice,
    landingPage: cap(getTrackingInfo(strings.TRACKING_LANDINGPAGE)),
    organicSource: cap(getTrackingInfo(strings.TRACKING_ORGANICSOURCE)),
    organicSourceName: cap(getTrackingInfo(strings.TRACKING_ORGANICSOURCENAME)),
    trafficSource: cap(getTrackingInfo(strings.TRACKING_TRAFFICSOURCE)),
    firstTrafficSource: cap(
      getTrackingInfo(strings.TRACKING_FIRSTTRAFFICSOURCE)
    ),
    utmCampaign: cap(getTrackingInfo(strings.TRACKING_UTMCAMPAIGN)),
    utmTerm: cap(getTrackingInfo(strings.TRACKING_UTMTERM)),
    utmMedium: cap(getTrackingInfo(strings.TRACKING_UTMMEDIUM)),
    utmSource: cap(getTrackingInfo(strings.TRACKING_UTMSOURCE)),
    utmContent: cap(getTrackingInfo(strings.TRACKING_UTMCONTENT)),
    survey: cap(formInputs.survey?.value ?? "", 100),
    surveyOther: cap(formInputs.surveyOther, 1000),
    isNewCompanyCampaign: isNewCampaignActivated(),
    newCompanyCampaignOptOut: formInputs.newCompanyCampaignOptOut === "1",
  };
}

// The optional chain is load-bearing, not redundant: companyForm?.label is cast to string but is undefined until the form field is picked, and omitting the key is the pre-existing behaviour Salesforce expects.
function cap(value: string, max = 250) {
  return value?.substring(0, max);
}
